const eclipses = [
  [-2196234369,'Total Solar'],
  [-2194893141,'Penumbral Lunar'],
  [-2180882395,'Annular Solar'],
  [-2179661603,'Penumbral Lunar'],
  [-2166845361,'Penumbral Lunar'],
  [-2165595968,'Total Solar'],
  [-2151564247,'Partial Lunar'],
  [-2150296248,'Annular Solar'],
  [-2137485308,'Partial Solar'],
  [-2136258445,'Total Lunar'],
  [-2134949150,'Partial Solar'],
  [-2120925384,'Total Lunar'],
  [-2119708778,'Partial Solar'],
  [-2106858255,'Annular Solar'],
  [-2105653640,'Partial Lunar'],
  [-2091640803,'Total Solar'],
  [-2090306539,'Partial Lunar'],
  [-2077563451,'Penumbral Lunar'],
  [-2076257959,'Annular Solar'],
  [-2075023681,'Penumbral Lunar'],
  [-2060997322,'Total Solar'],
  [-2059712685,'Penumbral Lunar'],
  [-2046920384,'Partial Lunar'],
  [-2045674040,'Annular Solar'],
  [-2031682745,'Partial Lunar'],
  [-2030352745,'Total Solar'],
  [-2016288771,'Total Lunar'],
  [-2015079393,'Partial Solar'],
  [-2002272334,'Partial Solar'],
  [-2001063595,'Total Lunar'],
  [-1999723630,'Partial Solar'],
  [-1987005239,'Total Solar'],
  [-1985682119,'Partial Lunar'],
  [-1971678949,'Annular Solar'],
  [-1970422674,'Partial Lunar'],
  [-1956363268,'Total Solar'],
  [-1955097482,'Penumbral Lunar'],
  [-1942307599,'Penumbral Lunar'],
  [-1941089401,'Annular Solar'],
  [-1939775142,'Penumbral Lunar'],
  [-1927073095,'Penumbral Lunar'],
  [-1925727365,'Hybrid Solar'],
  [-1911681049,'Total Lunar'],
  [-1910479274,'Hybrid Solar'],
  [-1896447924,'Total Lunar'],
  [-1895112925,'Partial Solar'],
  [-1882376286,'Total Solar'],
  [-1881080749,'Total Lunar'],
  [-1867096311,'Partial Solar'],
  [-1865806778,'Total Lunar'],
  [-1851730373,'Total Solar'],
  [-1850493827,'Penumbral Lunar'],
  [-1836503243,'Annular Solar'],
  [-1835166217,'Penumbral Lunar'],
  [-1822441594,'Partial Lunar'],
  [-1821097573,'Hybrid Solar'],
  [-1807100077,'Partial Lunar'],
  [-1805883814,'Total Solar'],
  [-1791806569,'Total Lunar'],
  [-1790490436,'Partial Solar'],
  [-1777777691,'Partial Solar'],
  [-1776510716,'Total Lunar'],
  [-1775243668,'Partial Solar'],
  [-1762472847,'Annular Solar'],
  [-1761162434,'Partial Lunar'],
  [-1747135537,'Total Solar'],
  [-1745921131,'Partial Lunar'],
  [-1733079717,'Penumbral Lunar'],
  [-1731871606,'Annular Solar'],
  [-1730526054,'Penumbral Lunar'],
  [-1717846562,'Penumbral Lunar'],
  [-1716512880,'Annular Solar'],
  [-1715308405,'Penumbral Lunar'],
  [-1702480793,'Partial Lunar'],
  [-1701244744,'Total Solar'],
  [-1687202057,'Partial Lunar'],
  [-1685915641,'Annular Solar'],
  [-1673147652,'Partial Solar'],
  [-1671898518,'Total Lunar'],
  [-1670603497,'Partial Solar'],
  [-1657881801,'Partial Solar'],
  [-1656555637,'Total Lunar'],
  [-1655327813,'Partial Solar'],
  [-1642516364,'Annular Solar'],
  [-1641305609,'Total Lunar'],
  [-1627264344,'Total Solar'],
  [-1625923927,'Partial Lunar'],
  [-1611909469,'Annular Solar'],
  [-1610686430,'Penumbral Lunar'],
  [-1597877145,'Penumbral Lunar'],
  [-1596624665,'Total Solar'],
  [-1582589748,'Partial Lunar'],
  [-1581324347,'Annular Solar'],
  [-1567289339,'Total Lunar'],
  [-1565977512,'Partial Solar'],
  [-1551952100,'Total Lunar'],
  [-1550736476,'Partial Solar'],
  [-1537886687,'Annular Solar'],
  [-1536682539,'Total Lunar'],
  [-1522668259,'Total Solar'],
  [-1521335187,'Partial Lunar'],
  [-1508589078,'Penumbral Lunar'],
  [-1507287263,'Annular Solar'],
  [-1506050875,'Penumbral Lunar'],
  [-1492024775,'Total Solar'],
  [-1490742970,'Penumbral Lunar'],
  [-1477945705,'Partial Lunar'],
  [-1476702947,'Annular Solar'],
  [-1462713618,'Partial Lunar'],
  [-1461381142,'Total Solar'],
  [-1447314701,'Total Lunar'],
  [-1446106597,'Partial Solar'],
  [-1433304107,'Partial Solar'],
  [-1432093177,'Total Lunar'],
  [-1430753812,'Partial Solar'],
  [-1418029588,'Total Solar'],
  [-1416709113,'Partial Lunar'],
  [-1402711884,'Annular Solar'],
  [-1401451623,'Partial Lunar'],
  [-1387387403,'Total Solar'],
  [-1386124797,'Penumbral Lunar'],
  [-1373337327,'Penumbral Lunar'],
  [-1372121686,'Annular Solar'],
  [-1370804414,'Penumbral Lunar'],
  [-1358098770,'Penumbral Lunar'],
  [-1356752230,'Annular Solar'],
  [-1342712163,'Total Lunar'],
  [-1341509848,'Total Solar'],
  [-1327472688,'Total Lunar'],
  [-1326139227,'Partial Solar'],
  [-1313404602,'Total Solar'],
  [-1312113051,'Total Lunar'],
  [-1310873597,'Partial Solar'],
  [-1298124693,'Partial Solar'],
  [-1296831508,'Total Lunar'],
  [-1282758578,'Total Solar'],
  [-1281525737,'Penumbral Lunar'],
  [-1267530936,'Annular Solar'],
  [-1266191853,'Penumbral Lunar'],
  [-1253469654,'Partial Lunar'],
  [-1252126561,'Hybrid Solar'],
  [-1238129589,'Partial Lunar'],
  [-1236910596,'Total Solar'],
  [-1222833151,'Total Lunar'],
  [-1221520480,'Partial Solar'],
  [-1208805553,'Partial Solar'],
  [-1207541514,'Total Lunar'],
  [-1206270282,'Partial Solar'],
  [-1193501063,'Annular Solar'],
  [-1192188455,'Partial Lunar'],
  [-1178164574,'Total Solar'],
  [-1176951563,'Partial Lunar'],
  [-1164105753,'Penumbral Lunar'],
  [-1162898018,'Annular Solar'],
  [-1161552441,'Penumbral Lunar'],
  [-1148876010,'Penumbral Lunar'],
  [-1147543819,'Annular Solar'],
  [-1146337660,'Penumbral Lunar'],
  [-1133507858,'Partial Lunar'],
  [-1132269673,'Total Solar'],
  [-1118231074,'Partial Lunar'],
  [-1116948144,'Annular Solar'],
  [-1102925562,'Total Lunar'],
  [-1101627833,'Partial Solar'],
  [-1088913613,'Partial Solar'],
  [-1087585189,'Total Lunar'],
  [-1086360206,'Partial Solar'],
  [-1073541645,'Annular Solar'],
  [-1072331446,'Total Lunar'],
  [-1058294385,'Total Solar'],
  [-1056954882,'Partial Lunar'],
  [-1042936299,'Annular Solar'],
  [-1041711057,'Penumbral Lunar'],
  [-1028909320,'Penumbral Lunar'],
  [-1027653554,'Total Solar'],
  [-1013614843,'Partial Lunar'],
  [-1012352046,'Annular Solar'],
  [-998320574,'Total Lunar'],
  [-997006200,'Total Solar'],
  [-982978398,'Total Lunar'],
  [-981763655,'Partial Solar'],
  [-968915689,'Annular Solar'],
  [-967711781,'Total Lunar'],
  [-953695172,'Total Solar'],
  [-952363383,'Partial Lunar'],
  [-939615118,'Penumbral Lunar'],
  [-938317131,'Annular Solar'],
  [-937078462,'Penumbral Lunar'],
  [-923051770,'Total Solar'],
  [-921772717,'Penumbral Lunar'],
  [-908971457,'Partial Lunar'],
  [-907732315,'Annular Solar'],
  [-893743982,'Partial Lunar'],
  [-892409163,'Total Solar'],
  [-878341067,'Total Lunar'],
  [-877134173,'Partial Solar'],
  [-864335743,'Partial Solar'],
  [-863122355,'Total Lunar'],
  [-861783680,'Partial Solar'],
  [-849054091,'Total Solar'],
  [-847736486,'Partial Lunar'],
  [-833744668,'Annular Solar'],
  [-832480312,'Partial Lunar'],
  [-818411635,'Total Solar'],
  [-817152339,'Penumbral Lunar'],
  [-804367186,'Penumbral Lunar'],
  [-803153808,'Annular Solar'],
  [-801833570,'Penumbral Lunar'],
  [-789124236,'Penumbral Lunar'],
  [-787777134,'Annular Solar'],
  [-773743527,'Partial Lunar'],
  [-772540336,'Total Solar'],
  [-758497193,'Total Lunar'],
  [-757165478,'Partial Solar'],
  [-744433191,'Partial Solar'],
  [-743145636,'Total Lunar'],
  [-741902880,'Partial Solar'],
  [-729152600,'Partial Solar'],
  [-727855940,'Total Lunar'],
  [-713787187,'Total Solar'],
  [-712557895,'Partial Lunar'],
  [-698558075,'Annular Solar'],
  [-697217157,'Penumbral Lunar'],
  [-684498098,'Partial Lunar'],
  [-683156072,'Hybrid Solar'],
  [-669158642,'Penumbral Lunar'],
  [-667936847,'Total Solar'],
  [-653860163,'Total Lunar'],
  [-652551091,'Partial Solar'],
  [-638571771,'Total Lunar'],
  [-637296419,'Partial Solar'],
  [-624529707,'Annular Solar'],
  [-623214957,'Total Lunar'],
  [-609193302,'Total Solar'],
  [-607981416,'Total Lunar'],
  [-593924776,'Annular Solar'],
  [-592579358,'Penumbral Lunar'],
  [-579905148,'Penumbral Lunar'],
  [-578574506,'Annular Solar'],
  [-577366411,'Penumbral Lunar'],
  [-564535227,'Partial Lunar'],
  [-563294905,'Total Solar'],
  [-549259930,'Partial Lunar'],
  [-547980384,'Annular Solar'],
  [-533952739,'Total Lunar'],
  [-532652433,'Partial Solar'],
  [-519945342,'Partial Solar'],
  [-518614725,'Total Lunar'],
  [-517392309,'Partial Solar'],
  [-504566902,'Annular Solar'],
  [-503357277,'Total Lunar'],
  [-489324438,'Total Solar'],
  [-487985947,'Partial Lunar'],
  [-473962996,'Annular Solar'],
  [-472735604,'Penumbral Lunar'],
  [-459941830,'Penumbral Lunar'],
  [-458682591,'Total Solar'],
  [-444639606,'Partial Lunar'],
  [-443379445,'Annular Solar'],
  [-429352108,'Partial Lunar'],
  [-428035178,'Total Solar'],
  [-414004335,'Total Lunar'],
  [-412790406,'Partial Solar'],
  [-399945269,'Annular Solar'],
  [-398741340,'Total Lunar'],
  [-384721570,'Total Solar'],
  [-383391167,'Total Lunar'],
  [-370641612,'Penumbral Lunar'],
  [-369347577,'Annular Solar'],
  [-368106436,'Partial Lunar'],
  [-354078314,'Total Solar'],
  [-352801948,'Penumbral Lunar'],
  [-339997699,'Partial Lunar'],
  [-338762173,'Annular Solar'],
  [-324773808,'Penumbral Lunar'],
  [-323436794,'Total Solar'],
  [-309367948,'Total Lunar'],
  [-308162165,'Partial Solar'],
  [-294151097,'Total Lunar'],
  [-292813200,'Partial Solar'],
  [-280078847,'Total Solar'],
  [-278764329,'Partial Lunar'],
  [-264777229,'Annular Solar'],
  [-263508701,'Partial Lunar'],
  [-249436073,'Total Solar'],
  [-248180208,'Penumbral Lunar'],
  [-235397115,'Penumbral Lunar'],
  [-234185695,'Annular Solar'],
  [-232862558,'Penumbral Lunar'],
  [-220149611,'Penumbral Lunar'],
  [-218802192,'Annular Solar'],
  [-204775074,'Partial Lunar'],
  [-203570675,'Total Solar'],
  [-189521543,'Total Lunar'],
  [-188191793,'Partial Solar'],
  [-175462007,'Partial Solar'],
  [-174178428,'Total Lunar'],
  [-172932153,'Partial Solar'],
  [-160180110,'Partial Solar'],
  [-158880167,'Total Lunar'],
  [-144816160,'Total Solar'],
  [-143590229,'Partial Lunar'],
  [-129584727,'Annular Solar'],
  [-128242203,'Penumbral Lunar'],
  [-115526900,'Penumbral Lunar'],
  [-114186073,'Annular Solar'],
  [-100187242,'Penumbral Lunar'],
  [-98962611,'Total Solar'],
  [-84887599,'Total Lunar'],
  [-83582238,'Partial Solar'],
  [-69601475,'Total Lunar'],
  [-68322100,'Total Solar'],
  [-55558806,'Partial Solar'],
  [-54241954,'Total Lunar'],
  [-40221676,'Total Solar'],
  [-39010671,'Total Lunar'],
  [-24951922,'Annular Solar'],
  [-23606834,'Penumbral Lunar'],
  [-10933921,'Penumbral Lunar'],
  [-9604879,'Annular Solar'],
  [-8394629,'Penumbral Lunar'],
  [4437012,'Partial Lunar'],
  [5679502,'Total Solar'],
  [19711438,'Partial Lunar'],
  [20987717,'Annular Solar'],
  [35019854,'Total Lunar'],
  [36322628,'Partial Solar'],
  [49023098,'Partial Solar'],
  [50355826,'Total Lunar'],
  [51575959,'Partial Solar'],
  [64407766,'Annular Solar'],
  [65616798,'Total Lunar'],
  [79645573,'Total Solar'],
  [80982962,'Partial Lunar'],
  [95010343,'Annular Solar'],
  [96239833,'Penumbral Lunar'],
  [109025409,'Penumbral Lunar'],
  [110288294,'Total Solar'],
  [111584336,'Penumbral Lunar'],
  [124335895,'Partial Lunar'],
  [125593365,'Annular Solar'],
  [139616137,'Partial Lunar'],
  [140935617,'Total Solar'],
  [154970036,'Total Lunar'],
  [156183190,'Partial Solar'],
  [169024607,'Partial Solar'],
  [170228841,'Total Lunar'],
  [184252526,'Partial Solar'],
  [185581428,'Total Lunar'],
  [199621425,'Annular Solar'],
  [200865242,'Partial Lunar'],
  [214895592,'Total Solar'],
  [216169319,'Penumbral Lunar'],
  [228975545,'Partial Lunar'],
  [230207493,'Annular Solar'],
  [244196937,'Penumbral Lunar'],
  [245535983,'Total Solar'],
  [259604611,'Total Lunar'],
  [260809421,'Partial Solar'],
  [274820637,'Total Lunar'],
  [276157668,'Partial Solar'],
  [288896073,'Total Solar'],
  [290207298,'Partial Lunar'],
  [304190519,'Annular Solar'],
  [305463262,'Total Lunar'],
  [319539198,'Total Solar'],
  [320791524,'Penumbral Lunar'],
  [333572957,'Penumbral Lunar'],
  [334782732,'Annular Solar'],
  [336108684,'Penumbral Lunar'],
  [348825001,'Penumbral Lunar'],
  [350172498,'Annular Solar'],
  [364193277,'Partial Lunar'],
  [365399208,'Total Solar'],
  [379454161,'Total Lunar'],
  [380781721,'Partial Solar'],
  [393509013,'Partial Solar'],
  [394788664,'Total Lunar'],
  [396038650,'Partial Solar'],
  [408792691,'Partial Solar'],
  [410095722,'Total Lunar'],
  [424154555,'Total Solar'],
  [425377348,'Partial Lunar'],
  [439389034,'Annular Solar'],
  [440732925,'Penumbral Lunar'],
  [453443982,'Penumbral Lunar'],
  [454783487,'Annular Solar'],
  [455984726,'Penumbral Lunar'],
  [468784586,'Penumbral Lunar'],
  [470012056,'Total Solar'],
  [484084567,'Total Lunar'],
  [485386130,'Partial Solar'],
  [499369366,'Total Lunar'],
  [500652643,'Total Solar'],
  [513411637,'Partial Solar'],
  [514730561,'Total Lunar'],
  [528750335,'Hybrid Solar'],
  [529960677,'Total Lunar'],
  [544020522,'Hybrid Solar'],
  [545365117,'Penumbral Lunar'],
  [559365116,'Annular Solar'],
  [560577705,'Penumbral Lunar'],
  [573408789,'Penumbral Lunar'],
  [574653508,'Total Solar'],
  [588683090,'Partial Lunar'],
  [589956231,'Annular Solar'],
  [603992140,'Total Lunar'],
  [605297292,'Partial Solar'],
  [619326537,'Total Lunar'],
  [620544672,'Partial Solar'],
  [633382259,'Annular Solar'],
  [634590692,'Total Lunar'],
  [648615728,'Total Solar'],
  [649951930,'Partial Lunar'],
  [663983619,'Annular Solar'],
  [665215163,'Penumbral Lunar'],
  [677992495,'Penumbral Lunar'],
  [679259175,'Total Solar'],
  [680551679,'Penumbral Lunar'],
  [693311585,'Partial Lunar'],
  [694566289,'Annular Solar'],
  [708584249,'Partial Lunar'],
  [709906260,'Total Solar'],
  [723944654,'Total Lunar'],
  [725157045,'Partial Solar'],
  [737993994,'Partial Solar'],
  [739198837,'Total Lunar'],
  [753227086,'Partial Solar'],
  [754554356,'Total Lunar'],
  [768589927,'Annular Solar'],
  [769836632,'Partial Lunar'],
  [783869942,'Total Solar'],
  [785141055,'Penumbral Lunar'],
  [797948278,'Partial Lunar'],
  [799176726,'Annular Solar'],
  [813168283,'Penumbral Lunar'],
  [814509186,'Total Solar'],
  [828576596,'Total Lunar'],
  [829780608,'Partial Solar'],
  [843792889,'Total Lunar'],
  [845128960,'Partial Solar'],
  [857870626,'Total Solar'],
  [859178367,'Partial Lunar'],
  [873158665,'Partial Solar'],
  [874435632,'Total Lunar'],
  [888514119,'Total Solar'],
  [889762817,'Penumbral Lunar'],
  [902543119,'Penumbral Lunar'],
  [903751563,'Annular Solar'],
  [905080227,'Penumbral Lunar'],
  [917799518,'Penumbral Lunar'],
  [919146861,'Annular Solar'],
  [933161630,'Partial Lunar'],
  [934369399,'Total Solar'],
  [948429839,'Total Lunar'],
  [949754980,'Partial Solar'],
  [962479950,'Partial Solar'],
  [963755752,'Total Lunar'],
  [965009616,'Partial Solar'],
  [977765723,'Partial Solar'],
  [979071648,'Total Lunar'],
  [993125041,'Total Solar'],
  [994344944,'Partial Lunar'],
  [1008363139,'Annular Solar'],
  [1009708155,'Penumbral Lunar'],
  [1022414620,'Penumbral Lunar'],
  [1023752688,'Annular Solar'],
  [1024954034,'Penumbral Lunar'],
  [1037756823,'Penumbral Lunar'],
  [1038987101,'Total Solar'],
  [1053056389,'Total Lunar'],
  [1054354094,'Annular Solar'],
  [1068340746,'Total Lunar'],
  [1069627777,'Total Solar'],
  [1082381651,'Partial Solar'],
  [1083702625,'Total Lunar'],
  [1097722767,'Partial Solar'],
  [1098932631,'Total Lunar'],
  [1112992563,'Hybrid Solar'],
  [1114336516,'Penumbral Lunar'],
  [1128335534,'Annular Solar'],
  [1129550604,'Partial Lunar'],
  [1142380063,'Penumbral Lunar'],
  [1143627099,'Total Solar'],
  [1157655092,'Partial Lunar'],
  [1158925224,'Annular Solar'],
  [1172964062,'Total Lunar'],
  [1174271525,'Partial Solar'],
  [1188297483,'Total Lunar'],
  [1189513901,'Partial Solar'],
  [1202356490,'Annular Solar'],
  [1203564335,'Total Lunar'],
  [1217586106,'Total Solar'],
  [1218921047,'Partial Lunar'],
  [1232956736,'Annular Solar'],
  [1234190307,'Penumbral Lunar'],
  [1246959530,'Penumbral Lunar'],
  [1248230131,'Total Solar'],
  [1249519157,'Penumbral Lunar'],
  [1262287385,'Partial Lunar'],
  [1263539232,'Annular Solar'],
  [1277552322,'Partial Lunar'],
  [1278876826,'Total Solar'],
  [1292919444,'Total Lunar'],
  [1294131065,'Partial Solar'],
  [1306962955,'Partial Solar'],
  [1308168724,'Total Lunar'],
  [1309509479,'Partial Solar'],
  [1322202064,'Partial Solar'],
  [1323527551,'Total Lunar'],
  [1337557993,'Annular Solar'],
  [1338807798,'Partial Lunar'],
  [1352844711,'Total Solar'],
  [1354113209,'Penumbral Lunar'],
  [1366920514,'Partial Lunar'],
  [1368145578,'Annular Solar'],
  [1369455062,'Penumbral Lunar'],
  [1382140237,'Penumbral Lunar'],
  [1383482808,'Hybrid Solar'],
  [1397548002,'Total Lunar'],
  [1398751428,'Annular Solar'],
  [1412765680,'Total Lunar'],
  [1414100692,'Partial Solar'],
  [1426844776,'Total Solar'],
  [1428148862,'Partial Lunar'],
  [1442127279,'Partial Solar'],
  [1443408447,'Total Lunar'],
  [1457488631,'Total Solar'],
  [1458733641,'Penumbral Lunar'],
  [1472720867,'Annular Solar'],
  [1474052123,'Penumbral Lunar'],
  [1486773855,'Penumbral Lunar'],
  [1488120819,'Annular Solar'],
  [1502130072,'Partial Lunar'],
  [1503339964,'Total Solar'],
  [1517405400,'Total Lunar'],
  [1518727893,'Partial Solar'],
  [1531450877,'Partial Solar'],
  [1532722932,'Total Lunar'],
  [1533980812,'Partial Solar'],
  [1546738888,'Partial Solar'],
  [1548047516,'Total Lunar'],
  [1562095364,'Total Solar'],
  [1563312650,'Partial Lunar'],
  [1577337495,'Annular Solar'],
  [1578683390,'Penumbral Lunar'],
  [1591385077,'Penumbral Lunar'],
  [1592721600,'Annular Solar'],
  [1593923389,'Penumbral Lunar'],
  [1606729408,'Penumbral Lunar'],
  [1607962443,'Total Solar'],
  [1622027914,'Total Lunar'],
  [1623321728,'Annular Solar'],
  [1637312620,'Partial Lunar'],
  [1638603239,'Total Solar'],
  [1651351269,'Partial Solar'],
  [1652674270,'Total Lunar'],
  [1666695622,'Partial Solar'],
  [1667905159,'Total Lunar'],
  [1681964213,'Hybrid Solar'],
  [1683307381,'Penumbral Lunar'],
  [1697306397,'Annular Solar'],
  [1698524054,'Partial Lunar'],
  [1711350796,'Penumbral Lunar'],
  [1712600266,'Total Solar'],
  [1726627485,'Partial Lunar'],
  [1727894737,'Annular Solar'],
  [1741935568,'Total Lunar'],
  [1743245294,'Partial Solar'],
  [1757268722,'Total Lunar'],
  [1758483691,'Partial Solar'],
  [1771330368,'Annular Solar'],
  [1772537660,'Total Lunar'],
  [1786556774,'Total Solar'],
  [1787890386,'Partial Lunar'],
  [1801929594,'Annular Solar'],
  [1803165185,'Penumbral Lunar'],
  [1817201227,'Total Solar'],
  [1818486857,'Penumbral Lunar'],
  [1831263194,'Partial Lunar'],
  [1832512086,'Annular Solar'],
  [1846520439,'Partial Lunar'],
  [1847847385,'Total Solar'],
  [1861894309,'Total Lunar'],
  [1863105143,'Partial Solar'],
  [1875931554,'Partial Solar'],
  [1877138573,'Total Lunar'],
  [1878478619,'Partial Solar'],
  [1891177385,'Partial Solar'],
  [1892500924,'Total Lunar'],
  [1906525686,'Annular Solar'],
  [1907778794,'Partial Lunar'],
  [1921819841,'Total Solar'],
  [1923085700,'Penumbral Lunar'],
  [1935892265,'Penumbral Lunar'],
  [1937114100,'Annular Solar'],
  [1938426261,'Penumbral Lunar'],
  [1951112775,'Penumbral Lunar'],
  [1952456811,'Hybrid Solar'],
  [1966518828,'Total Lunar'],
  [1967721912,'Annular Solar'],
  [1981738999,'Total Lunar'],
  [1983072844,'Partial Solar'],
  [1995818486,'Total Solar'],
  [1997118771,'Total Lunar'],
  [2011096403,'Partial Solar'],
  [2012381714,'Total Lunar'],
  [2026462678,'Total Solar'],
  [2027703969,'Penumbral Lunar'],
  [2041690687,'Annular Solar'],
  [2043024399,'Partial Lunar'],
  [2055747920,'Penumbral Lunar'],
  [2057094293,'Annular Solar'],
  [2071098672,'Partial Lunar'],
  [2072310945,'Total Solar'],
  [2086380745,'Total Lunar'],
  [2087700367,'Partial Solar'],
  [2100421848,'Partial Solar'],
  [2101690284,'Total Lunar'],
  [2102952285,'Partial Solar'],
  [2115712066,'Partial Solar'],
  [2117023221,'Total Lunar'],
  [2131065585,'Total Solar'],
  [2132280544,'Partial Lunar'],
  [2146311987,'Annular Solar'],
  [2147658516,'Penumbral Lunar'],
  [2160355408,'Penumbral Lunar'],
  [2161690289,'Annular Solar'],
  [2162892857,'Penumbral Lunar'],
  [2175702255,'Penumbral Lunar'],
  [2176937981,'Total Solar'],
  [2190999185,'Partial Lunar'],
  [2192289103,'Annular Solar'],
  [2206284912,'Partial Lunar'],
  [2207578940,'Total Solar'],
  [2220320523,'Partial Solar'],
  [2221645525,'Total Lunar'],
  [2235668873,'Partial Solar'],
  [2236878196,'Total Lunar'],
  [2250935482,'Total Solar'],
  [2252277731,'Partial Lunar'],
  [2266277697,'Annular Solar'],
  [2267498006,'Partial Lunar'],
  [2280320955,'Penumbral Lunar'],
  [2281572998,'Total Solar'],
  [2295600285,'Penumbral Lunar'],
  [2296864777,'Annular Solar'],
  [2310906610,'Total Lunar'],
  [2312218567,'Total Solar'],
  [2326240285,'Total Lunar'],
  [2327454056,'Annular Solar'],
  [2340303794,'Annular Solar'],
  [2341510599,'Total Lunar'],
  [2355527774,'Total Solar'],
  [2356859997,'Total Lunar'],
  [2370902085,'Annular Solar'],
  [2372139716,'Penumbral Lunar'],
  [2386172512,'Total Solar'],
  [2387454845,'Penumbral Lunar'],
  [2400238902,'Partial Lunar'],
  [2401484738,'Annular Solar'],
  [2415488674,'Partial Lunar'],
  [2416817992,'Total Solar'],
  [2430869137,'Total Lunar'],
  [2432079162,'Partial Solar'],
  [2444899853,'Partial Solar'],
  [2446108445,'Total Lunar'],
  [2447447686,'Partial Solar'],
  [2460152959,'Partial Solar'],
  [2461474366,'Total Lunar'],
  [2475493073,'Annular Solar'],
  [2476749677,'Partial Lunar'],
  [2490795262,'Total Solar'],
  [2492058429,'Penumbral Lunar'],
  [2504863558,'Penumbral Lunar'],
  [2506082353,'Annular Solar'],
  [2507397202,'Penumbral Lunar'],
  [2520085852,'Penumbral Lunar'],
  [2521431140,'Hybrid Solar'],
  [2535489089,'Total Lunar'],
  [2536692106,'Hybrid Solar'],
  [2550712823,'Total Lunar'],
  [2552045379,'Partial Solar'],
  [2564791741,'Partial Solar'],
  [2566088100,'Total Lunar'],
  [2580066064,'Partial Solar'],
  [2581355431,'Total Lunar'],
  [2595436221,'Total Solar'],
  [2596673798,'Penumbral Lunar'],
  [2610661056,'Annular Solar'],
  [2611997073,'Partial Lunar'],
  [2624721644,'Penumbral Lunar'],
  [2626067226,'Annular Solar'],
  [2640067502,'Penumbral Lunar'],
  [2641282383,'Total Solar'],
  [2655355790,'Total Lunar'],
  [2656672329,'Partial Solar'],
  [2669392927,'Partial Solar'],
  [2670657891,'Total Lunar'],
  [2671924083,'Partial Solar'],
  [2684685151,'Partial Solar'],
  [2685998668,'Total Lunar'],
  [2700035770,'Total Solar'],
  [2701248705,'Partial Lunar'],
  [2715286506,'Annular Solar'],
  [2716633429,'Penumbral Lunar'],
  [2729325679,'Penumbral Lunar'],
  [2730658829,'Annular Solar'],
  [2731862510,'Penumbral Lunar'],
  [2744675273,'Penumbral Lunar'],
  [2745913613,'Total Solar'],
  [2759970259,'Partial Lunar'],
  [2761256303,'Annular Solar'],
  [2775257543,'Partial Lunar'],
  [2776554791,'Total Solar'],
  [2789289467,'Partial Solar'],
  [2790616441,'Total Lunar'],
  [2791844274,'Partial Solar'],
  [2804642485,'Partial Solar'],
  [2805851676,'Total Lunar'],
  [2819906409,'Total Solar'],
  [2821247611,'Partial Lunar'],
  [2835249421,'Annular Solar'],
  [2836472411,'Partial Lunar'],
  [2849290542,'Penumbral Lunar'],
  [2850545314,'Total Solar'],
  [2864573510,'Penumbral Lunar'],
  [2865835347,'Annular Solar'],
  [2867112145,'Penumbral Lunar'],
  [2879877174,'Total Lunar'],
  [2881191345,'Total Solar'],
  [2895212212,'Total Lunar'],
  [2896425010,'Annular Solar'],
  [2909276703,'Partial Solar'],
  [2910483122,'Total Lunar'],
  [2924499160,'Partial Solar'],
  [2925829938,'Total Lunar'],
  [2939874128,'Annular Solar'],
  [2941113849,'Partial Lunar'],
  [2955144044,'Total Solar'],
  [2956423191,'Penumbral Lunar'],
  [2969214410,'Partial Lunar'],
  [2970457098,'Annular Solar'],
  [2984457108,'Partial Lunar'],
  [2985788713,'Total Solar'],
  [2999843821,'Total Lunar'],
  [3001053022,'Partial Solar'],
  [3013867929,'Partial Solar'],
  [3015078411,'Total Lunar'],
  [3016416755,'Partial Solar'],
  [3029128689,'Partial Solar'],
  [3030447769,'Total Lunar'],
  [3044460235,'Annular Solar'],
  [3045720508,'Partial Lunar'],
  [3059770888,'Total Solar'],
  [3061031290,'Penumbral Lunar'],
  [3073834427,'Penumbral Lunar'],
  [3075050407,'Annular Solar'],
  [3076367941,'Penumbral Lunar'],
  [3089059408,'Penumbral Lunar'],
  [3090405723,'Hybrid Solar'],
  [3104458815,'Partial Lunar'],
  [3105662060,'Total Solar'],
  [3119687112,'Total Lunar'],
  [3121018244,'Partial Solar'],
  [3133764538,'Partial Solar'],
  [3135056877,'Total Lunar'],
  [3136297873,'Partial Solar'],
  [3149036276,'Partial Solar'],
  [3150329581,'Total Lunar'],
  [3164409238,'Total Solar'],
  [3165643143,'Penumbral Lunar'],
  [3179631995,'Annular Solar'],
  [3180970149,'Partial Lunar'],
  [3193694974,'Penumbral Lunar'],
  [3195039576,'Annular Solar'],
  [3209036625,'Penumbral Lunar'],
  [3210254305,'Total Solar'],
  [3224330469,'Total Lunar'],
  [3225643725,'Partial Solar'],
  [3239625829,'Total Lunar'],
  [3240896249,'Total Solar'],
  [3253658040,'Partial Solar'],
  [3254973775,'Total Lunar'],
  [3269005990,'Total Solar'],
  [3270217209,'Total Lunar'],
  [3284260952,'Annular Solar'],
  [3285608033,'Penumbral Lunar'],
  [3298295961,'Penumbral Lunar'],
  [3299627304,'Annular Solar'],
  [3300832418,'Penumbral Lunar'],
  [3313648362,'Penumbral Lunar'],
  [3314889241,'Total Solar'],
  [3328941200,'Partial Lunar'],
  [3330223422,'Annular Solar'],
  [3344230421,'Partial Lunar'],
  [3345530699,'Total Solar'],
  [3358258173,'Partial Solar'],
  [3359587079,'Total Lunar'],
  [3360811751,'Partial Solar'],
  [3373616412,'Partial Solar'],
  [3374825517,'Total Lunar'],
  [3388877045,'Total Solar'],
  [3390217081,'Partial Lunar'],
  [3404221541,'Annular Solar'],
  [3405447209,'Partial Lunar'],
  [3418259580,'Penumbral Lunar'],
  [3419517251,'Total Solar'],
  [3433547168,'Penumbral Lunar'],
  [3434806436,'Annular Solar'],
  [3436087086,'Penumbral Lunar'],
  [3448847273,'Partial Lunar'],
  [3450163645,'Total Solar'],
  [3464184532,'Total Lunar'],
  [3465396553,'Annular Solar'],
  [3478249050,'Partial Solar'],
  [3479455220,'Total Lunar'],
  [3493470980,'Partial Solar'],
  [3494800260,'Total Lunar'],
  [3508845668,'Annular Solar'],
  [3510087559,'Partial Lunar'],
  [3524115885,'Total Solar'],
  [3525391965,'Penumbral Lunar'],
  [3538189639,'Partial Lunar'],
  [3539429099,'Annular Solar'],
  [3553425830,'Penumbral Lunar'],
  [3554759623,'Total Solar'],
  [3568818271,'Total Lunar'],
  [3570026649,'Partial Solar'],
  [3582835881,'Partial Solar'],
  [3584048556,'Total Lunar'],
  [3585385918,'Partial Solar'],
  [3598104495,'Partial Solar'],
  [3599421042,'Total Lunar'],
  [3613427276,'Annular Solar'],
  [3614691370,'Partial Lunar'],
  [3628746649,'Total Solar'],
  [3630004196,'Penumbral Lunar'],
  [3642804944,'Penumbral Lunar'],
  [3644018361,'Annular Solar'],
  [3645338562,'Penumbral Lunar'],
  [3658033392,'Penumbral Lunar'],
  [3659380502,'Annular Solar'],
  [3673428073,'Partial Lunar'],
  [3674631861,'Total Solar'],
  [3688661833,'Partial Lunar'],
  [3689991390,'Partial Solar'],
  [3702736913,'Partial Solar'],
  [3704025167,'Total Lunar'],
  [3705269073,'Partial Solar'],
  [3718007052,'Partial Solar'],
  [3719304154,'Total Lunar'],
  [3733381744,'Total Solar'],
  [3734612060,'Partial Lunar'],
  [3748603526,'Annular Solar'],
  [3749943638,'Partial Lunar'],
  [3762667895,'Penumbral Lunar'],
  [3764011340,'Annular Solar'],
  [3778006115,'Penumbral Lunar'],
  [3779226748,'Total Solar'],
  [3793304747,'Total Lunar'],
  [3794614536,'Partial Solar'],
  [3808594182,'Total Lunar'],
  [3809868832,'Total Solar'],
  [3822630663,'Partial Solar'],
  [3823948486,'Total Lunar'],
  [3837976328,'Total Solar'],
  [3839186140,'Total Lunar'],
  [3853235241,'Annular Solar'],
  [3854582256,'Penumbral Lunar'],
  [3867266339,'Penumbral Lunar'],
  [3868595810,'Annular Solar'],
  [3869802660,'Penumbral Lunar'],
  [3882621431,'Penumbral Lunar'],
  [3883864780,'Total Solar'],
  [3897912089,'Partial Lunar'],
  [3899190565,'Annular Solar'],
  [3913203458,'Partial Lunar'],
  [3914506581,'Total Solar'],
  [3927226726,'Partial Solar'],
  [3928557513,'Total Lunar'],
  [3929779276,'Partial Solar'],
  [3942590598,'Partial Solar'],
  [3943799640,'Total Lunar'],
  [3957847461,'Total Solar'],
  [3959186216,'Partial Lunar'],
  [3973194016,'Annular Solar'],
  [3974422332,'Partial Lunar'],
  [3987228116,'Penumbral Lunar'],
  [3988488860,'Total Solar'],
  [4002521258,'Penumbral Lunar'],
  [4003778018,'Annular Solar'],
  [4005062373,'Penumbral Lunar'],
  [4017816935,'Partial Lunar'],
  [4019135503,'Total Solar'],
  [4033157263,'Total Lunar'],
  [4034368670,'Annular Solar'],
  [4047220809,'Partial Solar'],
  [4048426903,'Total Lunar'],
  [4062443275,'Partial Solar'],
  [4063771000,'Total Lunar'],
  [4064985166,'Partial Solar'],
  [4077816665,'Annular Solar'],
  [4079060833,'Partial Lunar'],
  [4093088088,'Total Solar'],
  [4094361220,'Penumbral Lunar'],
  [4107164514,'Penumbral Lunar'],
  [4108400687,'Annular Solar'],
  [4122394919,'Penumbral Lunar'],
  [4123730788,'Total Solar'],
  [4137792397,'Total Lunar'],
  [4138999972,'Annular Solar'],
  [4153018952,'Total Lunar'],
  [4154355252,'Partial Solar'],
  [4167080283,'Partial Solar'],
  [4168394082,'Total Lunar'],
  [4182394295,'Annular Solar'],
  [4183662336,'Total Lunar'],
  [4197722454,'Total Solar'],
  [4198977042,'Penumbral Lunar'],
  [4211775172,'Penumbral Lunar'],
  [4212986305,'Annular Solar'],
  [4214309136,'Penumbral Lunar'],
  [4227007724,'Penumbral Lunar'],
  [4228355389,'Annular Solar'],
  [4242396926,'Partial Lunar'],
  [4243601581,'Total Solar'],
  [4257636925,'Partial Lunar'],
  [4258964739,'Annular Solar'],
  [4271708900,'Partial Solar'],
  [4272993033,'Total Lunar'],
  [4274240072,'Partial Solar'],
  [4286978375,'Partial Solar'],
  [4288279108,'Total Lunar'],
  [4302353756,'Total Solar'],
  [4303580601,'Partial Lunar'],
  [4317575643,'Annular Solar'],
  [4318917519,'Partial Lunar'],
  [4331640395,'Penumbral Lunar'],
  [4332982518,'Annular Solar'],
  [4334185578,'Penumbral Lunar'],
  [4346976016,'Penumbral Lunar'],
  [4348199719,'Total Solar'],
  [4362278591,'Total Lunar'],
  [4363584752,'Partial Solar'],
  [4377563009,'Partial Lunar'],
  [4378841858,'Total Solar'],
  [4391602945,'Partial Solar'],
  [4392922750,'Total Lunar'],
  [4406946852,'Partial Solar'],
  [4408155558,'Total Lunar'],
  [4422209291,'Annular Solar'],
  [4423556023,'Penumbral Lunar'],
  [4437564428,'Annular Solar'],
  [4438773297,'Partial Lunar'],
  [4451594374,'Penumbral Lunar'],
  [4452840141,'Total Solar'],
  [4466882994,'Partial Lunar'],
  [4468157824,'Annular Solar'],
  [4482176549,'Partial Lunar'],
  [4483482342,'Total Solar'],
  [4496195207,'Partial Solar'],
  [4497527814,'Total Lunar'],
  [4498746939,'Partial Solar'],
  [4511564966,'Partial Solar'],
  [4512773944,'Total Lunar'],
  [4526817721,'Total Solar'],
  [4528155091,'Partial Lunar'],
  [4542166781,'Annular Solar'],
  [4543397694,'Partial Lunar'],
  [4556196204,'Penumbral Lunar'],
  [4557460194,'Total Solar'],
  [4558756371,'Penumbral Lunar'],
  [4571495753,'Penumbral Lunar'],
  [4572750042,'Annular Solar'],
  [4574037938,'Penumbral Lunar'],
  [4586786204,'Partial Lunar'],
  [4588106959,'Total Solar'],
  [4602130399,'Partial Lunar'],
  [4603341322,'Annular Solar'],
  [4616191965,'Partial Solar'],
  [4617398193,'Total Lunar'],
  [4631416063,'Partial Solar'],
  [4632742174,'Total Lunar'],
  [4633958764,'Partial Solar'],
  [4646787093,'Annular Solar'],
  [4648033672,'Partial Lunar'],
  [4662060688,'Total Solar'],
  [4663330989,'Partial Lunar'],
  [4676138967,'Penumbral Lunar'],
  [4677371823,'Annular Solar'],
  [4691364442,'Penumbral Lunar'],
  [4692702259,'Total Solar'],
  [4706766115,'Total Lunar'],
  [4707972937,'Annular Solar'],
  [4721989664,'Total Lunar'],
  [4723324828,'Partial Solar'],
  [4736055959,'Partial Solar'],
  [4737366797,'Total Lunar'],
  [4751361386,'Annular Solar'],
  [4752633471,'Total Lunar'],
  [4766698207,'Total Solar'],
  [4767949728,'Penumbral Lunar'],
  [4780745179,'Penumbral Lunar'],
  [4781954326,'Annular Solar'],
  [4783279736,'Penumbral Lunar'],
  [4795982314,'Penumbral Lunar'],
  [4797330288,'Annular Solar'],
  [4811365447,'Partial Lunar'],
  [4812571298,'Total Solar'],
  [4826612313,'Partial Lunar'],
  [4827938201,'Annular Solar'],
  [4840680542,'Partial Solar'],
  [4841960550,'Total Lunar'],
  [4843210936,'Partial Solar'],
  [4855950207,'Partial Solar'],
  [4857254386,'Total Lunar'],
  [4871325301,'Total Solar'],
  [4872548834,'Partial Lunar'],
  [4886548320,'Annular Solar'],
  [4887891752,'Partial Lunar'],
  [4900612478,'Penumbral Lunar'],
  [4901953126,'Annular Solar'],
  [4903155732,'Penumbral Lunar'],
  [4915946360,'Penumbral Lunar'],
  [4917173208,'Total Solar'],
  [4931251986,'Total Lunar'],
  [4932554381,'Annular Solar'],
  [4946532356,'Partial Lunar'],
  [4947815337,'Total Solar'],
  [4960574834,'Partial Solar'],
  [4961896530,'Total Lunar'],
  [4975917626,'Partial Solar'],
  [4977125513,'Total Lunar'],
  [4991183032,'Annular Solar'],
  [4992529277,'Penumbral Lunar'],
  [5006533239,'Annular Solar'],
  [5007744381,'Partial Lunar'],
  [5020567092,'Penumbral Lunar'],
  [5021815244,'Total Solar'],
  [5035853985,'Partial Lunar'],
  [5037125292,'Annular Solar'],
  [5051149591,'Partial Lunar'],
  [5052457891,'Total Solar'],
  [5066498056,'Total Lunar'],
  [5067714830,'Partial Solar'],
  [5080539427,'Partial Solar'],
];

export default eclipses;
